module.exports = __webpack_public_path__ + "img/102006.635482ec.png";